import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaLinkedin } from "react-icons/fa";

import sanket from '../Images/TeamPhotos/sanketsir2 - Copy.png';
import gaurav from '../Images/TeamPhotos/gauravsir.png';
import ajita from '../Images/employeimges copy/ajita2new.png';
import praful from '../Images/employeimges copy/fullsize/prafullnewcover.png';
import minal from '../Images/employeimges copy/fullsize/minalcover.png';
import mandar from '../Images/employeimges copy/fullsize/mandarcover.png';
import abhishesk from '../Images/employeimges copy/fullsize/abhicover.png';
import amol from '../Images/employeimges copy/fullsize/amolcover.png';
import shweta from '../Images/employeimges copy/fullsize/swetacover.png';
import raksh from '../Images/employeimges copy/rakshanew.png';
import Vaishanvi from '../Images/employeimges copy/fullsize/vaishnavicover.png';
import janvi from '../Images/employeimges copy/fullsize/janvi2cover.png';
import ashish from '../Images/employeimges copy/fullsize/AFF_8973 copy.png';
import sanika from '../Images/employeimges copy/fullsize/sanikacover.png';



// without Background images------->
import director1 from '../Images/TeamPhotos/sanketsir2 - Copy.png';
import director2 from '../Images/TeamPhotos/gauravsir.png';
import member1 from '../Images/employeimges copy/ajita2new.png';
import member2 from '../Images/employeimges copy/IMG_3773 Background Removed.png';
import member3 from '../Images/employeimges copy/AFF_8962 copy Background Removed.png';
import member4 from '../Images/employeimges copy/AFF_8961 copy Background Removed.png';
import member5 from '../Images/employeimges copy/AFF_8967 copy Background Removed.png';
import member6 from '../Images/employeimges copy/AFF_8969 copy Background Removed.png';
import member7 from '../Images/employeimges copy/AFF_8975 copy Background Removed.png';
import member8 from '../Images/employeimges copy/rakshanew.png';
import member9 from '../Images/employeimges copy/AFF_8965 copy Background Removed.png';
import member10 from '../Images/employeimges copy/AFF_8981 copy Background Removed.png';
import member11 from '../Images/employeimges copy/AFF_8973 copy Background Removed.png';
import member12 from '../Images/employeimges copy/sanikaprofile.png';
import member13 from '../Images/employeimges copy/payal.png';
import member14 from '../Images/employeimges copy/Sharvari-removebg-preview.png';
import member15 from '../Images/employeimges copy/vickybg.png';
import member16 from '../Images/employeimges copy/Kishorbg.png';
import member17 from '../Images/employeimges copy/Sayalibg.png';
import member18 from '../Images/employeimges copy/bipashabg.png';







import { AppConstant } from '../AppConstant';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

const directors = [
    {
        name: 'Mr. Sanket Raut',
        position: 'Director & Structural Engineer',
        image: director1,
        cover: sanket,
        linkedin: 'https://www.linkedin.com/in/sanket-raut-11143798',
        about: 'Accomplished structural engineer with strong expertise in structural analysis, design optimization, and project execution. He has successfully led diverse projects, ranging from industrial plants and infrastructure developments to commercial and residential structures. With a deep focus on quality assurance, compliance with international standards, and sustainable engineering practices, he is committed to delivering safe, cost-effective, and innovative solutions. As a leader, he thrives on guiding teams, building client trust, and driving projects that combine technical precision with long-term reliability. Outside of work, he enjoys exploring new technologies, mentoring young engineers, and contributing to knowledge-sharing in the engineering community.',

        ribbon: "Director",
        ribbonColor: "#16a34a",
        qualifications: 'Master of Technology - MTech, Structural Engineering',
        email: 'sanket@structguard.com',
        offices: 'INDIA',
        expertise: [
            'Structural design & analysis',

            'Project execution & management',

            'Quality & safety assurance',

            'Value engineering & innovation',

            'Industrial & infrastructure projects',

            'Client-focused solutions',
        ],
        education: [
            'Master of Technology - MTech, Structural Engineering',
            'Bachelor of Engineering - BE, Civil Engineering',
        ],

    },
    {
        name: 'Mr. Gaurav Joshi',
        position: 'Director & Structural Engineer',
        image: director2,
        cover: gaurav,
        linkedin: 'https://www.linkedin.com/in/gaurav-joshi-4a012473',
        about: 'Accomplished Structural Engineer with extensive experience in structural design, detailing, project management, and operations management. He has a proven track record in designing reinforced concrete and steel multi-storey buildings, composite structures, and specialty projects, including airports, aircraft hangars and healthcare facilities. His expertise encompasses anchor and baseplate design, foundation, anchorage, and breakout reinforcement design for structures in high seismic zones. With a keen eye for detail and a commitment to excellence, he thrive in delivering innovative and safe engineering solutions. Outside of his professional endeavors, he enjoy drawing, traveling, and embarking on road trips, which fuel his creativity and enrich problem-solving skills. ',

        ribbon: "Director",
        ribbonColor: "#16a34a",
        qualifications: 'Master of Technology (Structural Engineering) - IIIT, Hyderabad',
        email: 'gaurav@structguard.com',
        offices: 'UNITED STATES OF AMERICA',
        expertise: [
            'Advanced structural design',

            'Structural safety & durability',

            'Quality assurance & compliance',

            'Project leadership & strategy',

            'Innovation in engineering',

            'Global project execution',
        ],
        education: [
            'Master of Technology (Structural Engineering) - IIIT, Hyderabad',
            'Bachelor of Technology (Civil Engineering) - SGGSIE&T, Nanded',
        ],

    },
];

const teamMembers = [
    {
        name: 'Ajita Kulkarni',
        position: 'Assistant Project Manager (APM)',
        image: member1,
        cover: ajita,
        about: 'Experienced structural design engineer with over 7 years in designing residential, commercial, and industrial structures. Proficient in structural analysis, steel and timber design, and code compliance using tools like STAAD.Pro, ETABS, and SAFE. Strong team leader with a client-focused approach and a passion for innovative structural solutions.',
        qualifications: 'M.E. (Structures)',

        // contact: '+91 7798719144',
        email: 'ajita.kulkarni@structguard.com',

        expertise: [
            'Steel design',

            'Lumber design',

            'RCC design',

            'Cold-formed steel design',

            'Aluminum structure design',

            'Design of glass houses',

            'Staircase design',

            'Precast design',

            'FEA analysis',

            'Connection design',
        ],
        education: [
            'M.E. (Structures) - MIT PUNE',
            'Bachelor of Engineering (Civil)',
        ],
        publications: 'Seismic Respones Enhancement of Steel Building Using Buckling Restrained Braces',
        ribbon: "Senior Staff",
        ribbonColor: "#2563eb",
    },
    // {
    //     name: 'Prafull Rongare',
    //     position: 'Team Leader',
    //     image: member2,
    //     cover: praful,
    //     about: 'Experienced structural design engineer with expertise in light gauge steel (LGS), hot rolled steel (HRS), connection detailing, and foundation design. Skilled in using advanced engineering software like Hilti PROFIS and CAD tools to deliver code-compliant, efficient steel structures. Proven track record across multiple firms, with a strong foundation in both site execution and structural analysis.',
    //     qualifications: 'M.Tech (Structure)',
    //     // contact: '+91 8975727798',
    //     email: 'prafull.rongare@structguard.com',
    //     expertise: [
    //         'Design of steel structures',

    //         'Steel connection design',

    //         'CFS',

    //         'Lumber',
    //     ],

    //     education: [
    //         'M.Tech (Structure)',
    //         'Bachelor of Engineering (Civil)',
    //     ],
    //     publications: 'Comparative  study of downburst loading against normal wind loading on transmission tower',
    //     ribbon: "Senior Staff",
    //     ribbonColor: "#2563eb",
    // },
    {
        name: 'Vicky Gaikwad',
        position: 'Assistant Project Manager (Detailer)',
        image: member15,
        cover: member15,
        about: 'I am a Structural Detailer with 14 years of experience in structural detailing and drafting, specialising in CFS (Cold-Formed Steel) structural and fabrication packages. My expertise includes 10 years of CFS structural & fabrication detailing, 2 years of RCC detailing, and 2 years of advanced steel and lumber detailing. I have extensive experience in developing accurate, construction-ready structural and fabrication drawings with a strong focus on quality, coordination, and constructability.',
        // qualifications: 'M.Tech (Structure)',
        //   contact: '+91 8975727798',
        email: 'vicky.gaikwad@structguard.com',
        expertise: [
            'Structural Steel & CFS/LGS Detailing',

            'Shop, GA & Erection Drawings',

            'Project Management & Client Coordination',

            'BIM/IFC Coordination & QA/QC',
        ],

        // education: [
        //     'Diploma',

        // ],
        publications: '',
        ribbon: "Senior Staff",
        ribbonColor: "#2563eb",
    },
    {
        name: 'Minal Harinkhede',
        position: 'Project Engineer',
        image: member3,
        cover: minal,
        about: 'Project engineer with 2 years of experience in steel and lumber structural design for residential and commercial projects. Proficient in STAAD.Pro, Idea Statica, and AutoCAD, with a strong understanding of international design codes. Detail-oriented, technically sound, and effective in cross-disciplinary collaboration and project execution.',
        qualifications: 'B-Tech (Civil Engineering)',
        // contact: '+91 9309573150',
        email: 'minal.harinkhede@structguard.com',
        expertise: [
            'Connection design',

            'Design of steel structure',

            'Lumber design',

            'CFS design',
        ],
        education: [
            'B-Tech (Civil Engineering)',
            'Diploma (Civil Engineering)',
        ],
        publications: '',
        ribbon: "Senior Staff",
        ribbonColor: "#2563eb",
    },
    {
        name: 'Bipasha Sethi',
        position: 'Design Engineer',
        image: member18,
        cover: member18,
        about: 'Design Engineer with experience of 2+ years in the analysis and design of wood, cold form steel and steel structures including residential and commercial structures. proficient in structural engineering modelling, load analysis, member design, wind load assesment and steel connection design by using enercalc, tekla tedds, forteweb, ram connections, visual analysis, mecawind, bluebeam, sika-carbudur.',
        qualifications: 'M.Tech Structural Engineering',
        // contact: '+91 8208264536 ',
        email: 'bipasha.sethi@structguard.com',
        expertise: [
            'STRUCTURES AND STEEL CONNECTIONS.',

            'Design Codes & Engineering Documentation',

            'Structural Analysis & Design',

            'DESIGN OF WOOD RESIDENTIAL',

        ],
        education: [
            'M.Tech Structural Engineering',
            'B.Tech in Civil Engineering',
            // 'Diploma in Civil Engineering – Government Polytechnic',

        ],
        publications: '',
    },
    // {
    //     name: 'Mandar Pawar',
    //     position: 'Project Engineer',
    //     image: member4,
    //     cover: mandar,
    //     about: 'Structural engineer with more than 2 years of experience in designing industrial steel structures for the oil and gas sector. Skilled in structural analysis, detailing, and design using STAAD.Pro, ETABS, and Idea Statica. Strong understanding of international codes with hands-on expertise in warehouse, equipment support, and foundation designs.',
    //     qualifications: 'Structural Engineering (M.E)',
    //     // contact: '+91 9146888404',
    //     email: 'mandar.pawar@structguard.com',
    //     expertise: [
    //         'Industrial steel structure',

    //         'RCC design',

    //         'Lumber design',

    //         'Connection design',
    //     ],
    //     education: [
    //         'Structural Engineering (M.E)',
    //         'B-Tech (Civil Engineering)',

    //     ],
    //     publications: 'Comparative Study on Seismic behaviour of Diagrid RC. Structure between level ground and sloping surfaces',
    // },
    // {
    //     name: 'Abhishek Bhosale',
    //     position: 'Structural Detailer',
    //     image: member5,
    //     cover: abhishesk,
    //     about: 'Detail-oriented CAD detailer with 1.5+ years of experience in preparing structural shop drawings for U.S. projects. Skilled in structural detailing, layout planning, and software like AutoCAD, STAAD.Pro, and Idea Statica. Strong foundation in framing, connections, and foundation detailing, with a growing focus on structural design and analysis.',
    //     qualifications: 'BE Civil',
    //     // contact: '-------',
    //     email: 'abhishek.bhosale@structguard.com',
    //     expertise: [
    //         'Structural drawings',
    //         'Revit modeling',

    //     ],
    //     education: [
    //         'B.E. (Civil Engineering)',

    //     ],
    //     publications: '',
    // },
    {
        name: 'Raksha Choure',
        position: 'Design Engineer',
        image: member8,
        cover: raksh,
        about: 'Junior civil design engineer with a solid foundation in structural design and site work. Hands-on experience through internships and current role at StructGuard Engineers LLP. Strong academic background in civil engineering and keen interest in sustainable construction methods like geopolymer concrete. Quick learner with a collaborative and proactive approach.',
        qualifications: 'B.E. (Civil Engineering)',
        // contact: '+91 9022962874',
        email: 'choure.raksha@structguard.com',
        expertise: [
            'Steel structure',
            'RCC structure',
        ],
        education: [
            'B.E. (Civil Engineering)',
            'Diploma (Civil Engineering)',

        ],
        publications: '',
    },
    {
        name: 'Amol Borse',
        position: 'Structural Detailer',
        image: member6,
        cover: amol,
        about: 'Motivated and detail-oriented junior CAD detailer with hands-on experience in preparing 2D and 3D CAD drawings using AutoCAD and Revit. Proven ability to interpret technical drawings, develop fabrication details, and collaborate with engineers for timely project delivery. Strong problem-solving skills, quick adaptability, and a team-first mindset make me a reliable contributor in structural design environments.',
        qualifications: 'B.E.Civil',
        // contact: '+91 9075212843 ',
        email: 'amol.borse@structguard.com',
        expertise: [
            'CAD detailer',

            'Revit modular',

        ],
        education: [
            'B.E.Civil',
            'Diploma (Civil Engineering)',

        ],
        publications: '',
    },
    {
        name: 'Shweta Chandwale',
        position: 'Design Engineer',
        image: member7,
        cover: shweta,
        about: 'Civil and structural engineer with hands-on experience in telecom tower design, foundation analysis, and CAD drafting. Skilled in AutoCAD and STAAD.Pro, with a track record of supporting cross-functional teams and delivering safe, compliant structures. Detail-oriented, quick learner, and a strong team player.',
        qualifications: 'B.E.Civil',
        // contact: '+91 8208264536 ',
        email: 'shweta.chandawale@structguard.com',
        expertise: [
            'Steel design',

            'Lumber design',

            'RCC design',

            'CFS design',
        ],
        education: [
            'B.E.Civil',
            'Diploma (Civil Engineering)',

        ],
        publications: 'A review on lining materials for artificial lake ',
    },

    {
        name: 'Kishor More',
        position: 'Design Engineer',
        image: member16,
        cover: member16,
        about: 'Structural Design Engineer with 2.5+ years of experience in RCC building design and structural analysis. Experienced in structural modelling, analysis, design, detailing, and preparation of technical reports using STAAD.Pro and related engineering tools.',
        qualifications: 'B.Tech in Civil Engineering',
        // contact: '+91 8208264536 ',
        email: 'kishor.more@structguard.com',
        expertise: [
            'RCC Structural Design',

            'Structural Analysis',

            'Structural Detailing',

            'BOQ Preparation & IS Codes',
        ],
        education: [
            'B.Tech in Civil Engineering',

        ],
        publications: '',
    },
    {
        name: 'Payal kajave',
        position: 'Jr.Design Engineer',
        image: member13,
        cover: member13,
        about: 'Civil Engineer with hands-on experience in structural design, detailing, and analysis of RCC and steel structures. Proficient in ETABS, STAAD Pro, AutoCAD, and Revit, with experience in residential, commercial, and industrial building projects.',
        qualifications: 'B.Tech in Civil Engineering',
        // contact: '+91 8208264536 ',
        email: 'payal.kajave@structguard.com',
        expertise: [
            'Structural Design & Analysis',

            'Steel Structures',

            'RCC design',

            'Structural Detailing',
        ],
        education: [
            'B.Tech in Civil Engineering – Department of Technology',
            'Diploma in Civil Engineering – Government Polytechnic',

        ],
        publications: '',
    },
    {
        name: 'Sayali Deshpande',
        position: 'Trainee Design Engineer',
        image: member17,
        cover: member17,
        about: 'Sayali dedicated Structural Design Engineer holding an M.Tech in Structural Engineering, specializing in the analysis, design, and optimization of safe, sustainable, and code-compliant structures. With advanced academic training and practical expertise in both Reinforced Cement Concrete (RCC) and Steel.',
        qualifications: 'M.Tech Structural Engineering',
        // contact: '+91 8208264536 ',
        email: 'sayali.deshpande@structguard.com',
        expertise: [
            'Design Codes & Engineering Documentation',

            'Structural Analysis & Design',

            'RCC design',

            // 'Structural Detailing',
        ],
        education: [
            'M.Tech Structural Engineering',
            'B.Tech in Civil Engineering',
            // 'Diploma in Civil Engineering – Government Polytechnic',

        ],
        publications: '',
    },


    // {
    //     name: 'Sharvari Jain',
    //     position: ' Trainee Design Engineer',
    //     image: member14,
    //     cover: member14,
    //     about: '',
    //     qualifications: '',
    //     // contact: '+91 8208264536 ',
    //     email: 'sharvari.jain@structguard.com',
    //     expertise: [
    //         'Steel design',

    //         'Lumber design',

    //         'RCC design',

    //         'CFS design',
    //     ],
    //     education: [
    //         '',
    //         '',

    //     ],
    //     publications: '',
    // },
    {
        name: 'Vaishanvi Bhalerao',
        position: 'HR / Finance',
        image: member9,
        cover: Vaishanvi,
        about: 'Finance professional with an MBA in Accounting and Finance (2025) and over a year of experience as a financial advisor. Skilled in financial modeling, accounting, and client relationship management. Committed to delivering strategic financial solutions and building a strong foundation in investment planning and advisory services.',
        qualifications: 'Master of Business Administration (MBA)',
        // contact: '+91 7448154616',
        email: 'vaishnavi.bhalerao@structguard.com',
        expertise: [
            'Financial modeling & analysis',

            'Accounting & bookkeeping',

            'Investment planning & advisory',

            'Client relationship management',
        ],
        education: [
            'Master of Business Administration (MBA)',
            'Bachelor of Commerce',

        ],
        publications: 'Rohit Sharma: A Comprehensive Analysis of a modern Cricket Legend',

    },
    // {
    //     name: 'Janvi Gaddam',
    //     position: 'BDE',
    //     image: member10,
    //     cover: janvi,
    //     about: 'MBA graduate in finance (2025) with a strong foundation in financial management, investment analysis, and business strategy. Experienced as a business development executive with a proven ability to identify growth opportunities, manage client relationships, and support project execution. Combines financial knowledge with strategic thinking and communication skills to drive business success.',
    //     qualifications: 'Master of Business Administration (MBA)',
    //     // contact: '+91 9518774119',
    //     email: 'janvi.gaddam@structguard.com',

    //     expertise: [
    //         'Business development & client acquisition',

    //         'Lead generation & relationship management',

    //     ],
    //     education: [
    //         'Master of Business Administration (MBA)',
    //         'Bachelor of Business Administration (BBA)',

    //     ],
    //     publications: '',

    // },
    {
        name: 'Ashish More',
        position: 'Developer',
        image: member11,
        cover: ashish,
        about: 'Frontend developer with 2.5+ years of experience specializing in React.js and React Native. Strong background in JavaScript, HTML, CSS, and SQL, with hands-on expertise in building responsive web and mobile applications. Known for strong time management, problem-solving, and a passion for clean, scalable code.',
        qualifications: 'Master of Computer Science',
        // contact: '+91 9657920009',
        email: 'ashish.more@structguard.com',

        expertise: [
            'React.JS & React Native development',

            'JavaScript, UI/UX design, HTML & CSS',

            'Responsive web & mobile applications',

            'Business development & client acquisition',

            'Lead generation & relationship management',
        ],
        education: [
            'Master of Computer Science (M-CS)',
            'Bachelor of Computer Science (B-CS)',

        ],
        publications: '',

    },
    {
        name: 'Sanika Newasker',
        position: 'Business Development Executive',
        image: member12,
        cover: sanika,
        about: 'Sanika holds an MBA in Marketing and is an experienced business development executive. She specializes in generating leads, building client relationships, and delivering personalized solutions that drive business growth. Passionate about turning insights into impactful strategies, she thrives in dynamic, results-driven environments.',
        qualifications: 'Master of Business Administration (MBA)',
        // contact: '+91 9518774119',
        email: 'Sanika.Newasker@structguard.com',
        expertise: [
            'Lead generation',

            'Sales & relationship management',

            'Market research & analysis',

            'Strategic planning & proposal management',

        ],
        education: [
            'Master of Business Administration (MBA)',
            'Bachelor of Commerce (B-Com)',

        ],
        publications: '',

    },
];

const OurTeam = () => {

    const [selectedProfile, setSelectedProfile] = useState(null);
    const navigate = useNavigate();

    return (
        <>
            {/* <Header /> */}
            <div style={styles.container}>

                {/* <h2 style={styles.maintitle}>
                Meet <span style={styles.highlight}>Our Team</span>
            </h2> */}

                <h2 style={{ color: "#0A1733", fontSize: '60px', textAlign: 'center' }}>
                    Meet Our<span style={{ color: '#f37021' }}> StructGuardians</span>
                </h2>

                {/* 🔶 Directors Section */}
                <div style={{
                    maxWidth: "1200px",
                    margin: "0 auto 40px",   // top 0, auto left/right, 40px bottom
                    display: "grid",
                    gap: "2rem",
                    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                    alignItems: "start",
                    justifyContent: "center" // ✅ center the cards in last row
                }
                }>
                    {/* {directors.map((director, index) => (
                    <motion.div
                        key={index}
                        style={styles.directorCard}
                        whileHover={{ scale: 1.05 }}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.2 }}
                        // onClick={() => setSelectedProfile(director)}
                        onClick={() => navigate('/team-member-details', { state: { member: director } })}

                    >
                        <div style={styles.imageWrapper}>
                            <img src={director.image} alt={director.name} style={styles.image} />
                        </div>
                        <h3>{director.name}</h3>
                        <p style={styles.position}>{director.position}</p>
                        <a href={director.linkedin} target="_blank" rel="noreferrer">
                            <i className="fab fa-linkedin" style={styles.icon}></i>
                        </a>
                    </motion.div>
                ))} */}

                    {directors.map((director, index) => (

                        <article
                            key={index}
                            style={styles.card}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.transform = styles.cardHover.transform)
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = "translateY(0)")
                            }
                            onClick={() => navigate('/SecTeamMemberDetails', { state: { director } })}

                        >
                            {/* {director.ribbon && (
                                <div
                                    style={{
                                        ...styles.ribbon,
                                        background: director.ribbonColor || "#111827",
                                    }}
                                >
                                    {director.ribbon}
                                </div>
                            )} */}

                            <div style={styles.imageWrap}>
                                <img src={director.image} alt={director.name} style={styles.photo} />
                                <div style={styles.curve} />
                            </div>

                            {/* <div style={styles.info}>
                            <div style={styles.position}>{director.position}</div>
                            <div style={styles.name}>{director.name}</div>
                            <a href={director.linkedin} target="_blank" rel="noreferrer">
                                <i className="fab fa-linkedin" style={styles.icon}></i>
                            </a>
                        </div> */}
                            <div style={styles.info}>
                                <div style={styles.textBlock}>
                                    <div style={styles.position}>{director.position}</div>
                                    <div style={styles.name}>{director.name}</div>
                                </div>

                                <a href={director.linkedin} target="_blank" rel="noreferrer">
                                    <i className="fab fa-linkedin" style={styles.icon}></i>
                                </a>
                            </div>


                            {/* ✅ LinkedIn Icon */}
                            {/* {director.linkedin && (
                            <a
                                href={director.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    marginTop: "8px",
                                    color: "#0A66C2",
                                    fontSize: "1.5rem",
                                }}
                                onClick={(e) => e.stopPropagation()} // prevent triggering navigate()
                            >
                                <FaLinkedin />
                            </a>
                        )} */}
                        </article>
                    ))}

                </div>

                {/* 🔷 Team Members Section */}
                {/* <div style={styles.memberGrid}>
                {teamMembers.map((member, index) => (
                    <motion.div
                        key={index}
                        style={styles.memberCard}
                        whileHover={{ scale: 1.05 }}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.2 }}
                        // onClick={() => setSelectedProfile(member)}
                        onClick={() => navigate('/SecTeamMemberDetails', { state: { member } })}

                    >
                        <div style={styles.imageWrapper}>
                            <img src={member.image} alt={member.name} style={styles.image} />
                        </div>
                        <h4>{member.name}</h4>
                        <p style={styles.position}>{member.position}</p>
                    </motion.div>

                ))}




                {selectedProfile && (
                    <div style={styles.modalOverlay} onClick={() => setSelectedProfile(null)}>
                        <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                            <img src={selectedProfile.image} alt={selectedProfile.name} style={styles.modalImage} />
                            <h2 style={{ textDecoration: 'underline', letterSpacing: '2px' }}>
                                {selectedProfile.name}
                            </h2>
                            <p style={styles.position}>{selectedProfile.position}</p>
                            <p style={styles.about}>{selectedProfile.about}</p>
                       
                            <button onClick={() => setSelectedProfile(null)} style={styles.closeBtn}>Close</button>
                        </div>
                    </div>
                )}

            </div> */}

                <div style={styles.grid}>
                    {teamMembers.map((member, index) => (
                        <article
                            key={index}
                            style={styles.card}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.transform = styles.cardHover.transform)
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.transform = "translateY(0)")
                            }
                            onClick={() => navigate('/SecTeamMemberDetails', { state: { member } })}

                        >
                            {/* {member.ribbon && (
                                <div
                                    style={{
                                        ...styles.ribbon,
                                        background: member.ribbonColor || "#111827",
                                    }}
                                >
                                    {member.ribbon}
                                </div>
                            )} */}

                            <div style={styles.imageWrap}>
                                <img src={member.image} alt={member.name} style={styles.photo} />
                                <div style={styles.curve} />
                            </div>

                            <div style={styles.empinfo}>
                                <div style={styles.empposition}>{member.position}</div>
                                <div style={styles.empname}>{member.name}</div>
                            </div>
                        </article>
                    ))}
                </div>

            </div>
            {/* <Footer /> */}
        </>
    );
};

const styles = {
    container: {
        // padding: '4rem 2rem',
        // backgroundImage: `url("https://www.transparenttextures.com/patterns/stardust.png"),linear-gradient(to right, #0f2027, #203a43, #2c5364)`,
        // backgroundImage: ` url(${require('../Images/imagetemambg.png')})`,
        minHeight: '100vh',
        backgroundColor: "white",
        // backgroundImage: AppConstant.backgroundtextilerdesign,
        // backgroundAttachment: AppConstant.backgroundAttachmentscroller,
        width: "100%",

        color: 'black',
        fontFamily: 'Segoe UI, sans-serif',

        // backdropFilter: 'blur(4px)',
    },
    maintitle: {
        textAlign: 'center',
        fontSize: '2.8rem',
        marginBottom: '3rem',
        fontWeight: 'bold',
        color: '#fff',
        textShadow: '1px 1px 5px rgba(0,0,0,0.6)',
    },
    highlight: {
        color: '#F37021',
    },
    directorGrid: {
        display: 'flex',
        justifyContent: 'center',
        gap: '2rem',
        marginBottom: '3rem',
        flexWrap: 'wrap',
    },
    directorCard: {
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '15px',
        padding: '1.5rem',
        width: '280px',
        textAlign: 'center',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        backdropFilter: 'blur(10px)',
        color: '#fff',
    },
    memberGrid: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '1.5rem',
    },
    memberCard: {
        background: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '12px',
        padding: '1.2rem',
        width: '220px',
        textAlign: 'center',
        boxShadow: '0 5px 15px rgba(0,0,0,0.15)',
        backdropFilter: 'blur(8px)',
        color: '#fff',
    },
    imageWrapper: {
        position: 'relative',
        width: '100%',
        height: '230px',
        overflow: 'hidden',
        // background: 'linear-gradient(to top, white 20%, transparent 70%)', // 🔴 Half red
        // borderRadius: '20px',
        marginBottom: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
    position: {
        color: '#F37021',
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    modalOverlay: {
        position: 'fixed',
        top: 0, left: 0,
        width: '100vw',
        height: '300vh',
        backgroundColor: 'rgba(0,0,0,0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 999,
        padding: '10%'
    },
    info: {
        padding: "1rem 1rem 1.25rem",
        display: "flex",                // ✅ flex layout
        alignItems: "center",           // ✅ vertical center
        justifyContent: "space-between", // ✅ push icon to right
        borderRight: "5px solid #0A1733",

    },
    textBlock: {
        display: "flex",
        flexDirection: "column",
    },
    position: {
        fontSize: "1.05rem",
        color: "#6b7280",
        marginBottom: "0.25rem",
    },
    name: {
        fontSize: "1.50rem",
        fontWeight: "800",
        color: "#0b0b0b",
    },
    icon: {
        fontSize: "1.5rem",
        color: "#0A66C2",
    },
    empinfo: {
        padding: "1rem 1rem 1.25rem",
        borderRight: "5px solid #0A1733",
    },
    empposition: {
        fontSize: "1.05rem",
        color: "#6b7280",
        marginBottom: "0.25rem",
    },
    empname: {
        fontSize: "1.50rem",
        fontWeight: "800",
        color: "#0b0b0b",
        // color: '#F37021'
    },


    modalContent: {
        background: '#fff',
        padding: '2rem',
        borderRadius: '12px',
        textAlign: 'center',
        maxWidth: '400px',
        width: '80%',
        color: '#000',
        // position: 'relative',

    },
    modalImage: {
        width: '100%',
        height: '400px',
        objectFit: 'cover',
        borderRadius: '10px',
        marginBottom: '1rem',
    },
    modalLink: {
        display: 'inline-block',
        marginTop: '1rem',
        color: '#0077b5',
        fontWeight: 'bold',
        textDecoration: 'none',
    },
    closeBtn: {
        marginTop: '1.5rem',
        backgroundColor: '#F37021',
        color: '#fff',
        border: 'none',
        padding: '0.6rem 1.2rem',
        borderRadius: '6px',
        cursor: 'pointer',
        margin: '2%'
    },
    about: {
        fontSize: '0.95rem',
        color: '#333',
        marginTop: '0.8rem',
        lineHeight: '1.5',
    },
    wrap: {
        background: "#f6f7f9",
        minHeight: "100vh",
        padding: "3rem 1.25rem",
        fontFamily: "Segoe UI, system-ui, -apple-system, Arial, sans-serif",
        color: "#0b0b0b",
    },
    title: {
        maxWidth: "1200px",
        margin: "0 auto 2rem",
        fontSize: "1.75rem",
        fontWeight: "600",
    },
    grid: {
        maxWidth: "1200px",
        margin: "0 auto",
        display: "grid",
        gap: "2rem",
        gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
        alignItems: "start",

        // maxWidth: "1200px",
        // // margin: "2%",
        // display: "grid",
        // gap: "2rem",
        // gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
        // alignItems: "center",
        // // backgroundColor:'red',
        // justifySelf: 'center'

    },
    card: {
        position: "relative",
        width: "100%",
        background: "#ffffff",
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "0 8px 24px rgba(16, 24, 40, 0.08)",
        transition: "transform 160ms ease, box-shadow 160ms ease",
        border: `4px solid lightgrey`,
    },
    cardHover: {
        transform: "translateY(-2px)",
        boxShadow: "0 14px 32px rgba(16, 24, 40, 0.12)",
    },
    imageWrap: {
        position: "relative",
        height: "340px",
        background: "#e9eef3",
        overflow: "hidden",
    },
    photo: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        display: "block",
    },
    curve: {
        position: "absolute",
        left: "0",
        bottom: "-1px",
        width: "100%",
        height: "58px",
        background: "white",
        borderTopLeftRadius: "110px 58px",
        borderTop: "5px solid #F37021",
        borderRight: "5px solid #F37021", // straight right border
        boxSizing: "border-box",           // include border in width
    },
    // curve: {
    //     position: "absolute",
    //     left: "0",
    //     bottom: "-1px",
    //     width: "calc(100% )", // leave space for right border
    //     height: "58px",
    //     background: "white",
    //     borderTopLeftRadius: "110px ",
    //     borderTopRightRadius: "100px 78px",
    //     borderTop: "5px solid #F37021",
    //     borderRight: "5px solid #F37021",
    //     boxSizing: "border-box", // ensures border is included in width
    // },

    ribbon: {
        position: "absolute",
        top: "14px",
        right: "-46px",
        width: "160px",
        height: "28px",
        lineHeight: "28px",
        textAlign: "center",
        color: "#fff",
        fontSize: "0.78rem",
        fontWeight: "600",
        letterSpacing: "0.2px",
        transform: "rotate(45deg)",
        zIndex: 2,
        boxShadow: "0 6px 14px rgba(0, 0, 0, 0.18)",
    },


};


export default OurTeam;


// import React from 'react';
// import { motion } from 'framer-motion';
// import { useNavigate } from 'react-router-dom';

// import director1 from '../Images/TeamPhotos/sanket Background Removed.png';
// import director2 from '../Images/TeamPhotos/Gaurav_New5 Background Removed.png';
// import member1 from '../Images/employeimges copy/AFF_8978 copy.jpg';
// import member2 from '../Images/employeimges copy/IMG_3773.jpg';
// import member3 from '../Images/employeimges copy/AFF_8962 copy.jpg';
// import member4 from '../Images/employeimges copy/AFF_8961 copy.jpg';
// import member5 from '../Images/employeimges copy/AFF_8967 copy.jpg';
// import member6 from '../Images/employeimges copy/AFF_8969 copy.jpg';
// import member7 from '../Images/employeimges copy/AFF_8975 copy.jpg';
// import member8 from '../Images/employeimges copy/AFF_8968 copy.jpg';
// import member9 from '../Images/employeimges copy/AFF_8965 copy.jpg';
// import member10 from '../Images/employeimges copy/AFF_8981 copy.jpg';
// import member11 from '../Images/employeimges copy/AFF_8973 copy.jpg';
// import ajita from '../Images/employeimges copy/fullsize/ajitacover.png';
// import praful from '../Images/employeimges copy/fullsize/prafullnewcover.png';
// import minal from '../Images/employeimges copy/fullsize/minalcover.png';
// import mandar from '../Images/employeimges copy/fullsize/mandarcover.png';
// import abhishesk from '../Images/employeimges copy/fullsize/abhicover.png';
// import amol from '../Images/employeimges copy/fullsize/amolcover.png';
// import shweta from '../Images/employeimges copy/fullsize/swetacover.png';
// import raksh from '../Images/employeimges copy/fullsize/rakshacover.png';
// import Vaishanvi from '../Images/employeimges copy/fullsize/vaishnavicover.png';
// import janvi from '../Images/employeimges copy/fullsize/janvi2cover.png';
// import ashish from '../Images/employeimges copy/fullsize/ashishcover.png';

// const OurTeam = () => {
//     const navigate = useNavigate();


//     const directors = [
//         {
//             name: 'Mr. Sanket Raut',
//             position: 'Director & Structural Engineer',
//             image: director1,
//             linkedin: 'https://www.linkedin.com/in/sanket-raut-11143798',
//             about: 'Mr. Raut has over 10 years of experience in structural engineering, specializing in high-rise and seismic design.',
//         },
//         {
//             name: 'Mr. Gaurav Joshi',
//             position: 'Director & Structural Engineer',
//             image: director2,
//             linkedin: 'https://www.linkedin.com/in/gaurav-joshi-4a012473',
//             about: 'Gaurav Joshi leads the design team and focuses on steel and concrete structures across India and abroad.',
//         },
//     ];

//     const teamMembers = [
//         {
//             name: 'Ajita Kulkarni',
//             position: 'Assistant Project Manager (APM)',
//             image: member1,
//             cover: ajita,
//             about: 'Experienced Structural Design Engineer with over 6.5 years in designing residential, commercial, and industrial structures. Proficient in structural analysis, steel and timber design, and code compliance using tools like STAAD-Pro, ETABS, and SAFE. Strong team leader with a client-focused approach and a passion for innovative structural solutions.',
//             qualifications: 'M.E. (Structures)',

//             // contact: '+91 7798719144',
//             email: 'ajita.kulkarni@structguard.com',
//             offices: 'Pune',
//             services: 'Structural Engineering',
//             markets: '--------------',
//             expertise: [
//                 'Seismic Analysis & Design',
//                 'High Rise Building',
//                 'Steel Structures',
//                 'Reinforced Concrete Structures',
//             ],
//             education: [
//                 'M.E. (Structures) - MIT PUNE',
//                 'Bachelor of Engineering (Civil)',
//             ],
//             publications: 'Optimization Techniques for Precast Construction Industry, Roof Design of Narendra Modi Stadium',
//         },
//         {
//             name: 'Prafull Rongare',
//             position: 'Project Engineer',
//             image: member2,
//             cover: praful,
//             about: 'Experienced Structural Design Engineer with expertise in Light Gauge Steel (LGS), Hot Rolled Steel (HRS), connection detailing, and foundation design. Skilled in using advanced engineering software like Hilti Profis and CAD tools to deliver code-compliant, efficient steel structures. Proven track record across multiple firms, with a strong foundation in both site execution and structural analysis.',
//             qualifications: 'M.Tech (Structure)',
//             // contact: '+91 8975727798',
//             email: 'prafull.rongare@structguard.com',
//             offices: 'Pune',
//             services: 'Structural Engineering',
//             markets: '---------------',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],

//             education: [
//                 'M.Tech (Structure)',
//                 'Bachelor of Engineering (Civil)',
//             ],
//             publications: '-----------------',
//         },
//         {
//             name: 'Minal Harinkhede',
//             position: 'Project Engineer',
//             image: member3,
//             cover: minal,
//             about: 'Project Engineer with 2 years of experience in steel and lumber structural design for residential and commercial projects. Proficient in STAAD Pro, Idea Statica, and AutoCAD, with a strong understanding of international design codes. Detail-oriented, technically sound, and effective in cross-disciplinary collaboration and project execution.',
//             qualifications: 'B-Tech (Civil Engineering)',
//             // contact: '+91 9309573150',
//             email: 'minal.harinkhede@structguard.com',
//             offices: 'Pune',
//             services: 'Structural Engineering',
//             markets: '',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],
//             education: [
//                 'B-Tech (Civil Engineering)',
//                 'Diploma (Civil Engineering)',
//             ],
//             publications: '---------------',
//         },
//         {
//             name: 'Mandar Pawar',
//             position: 'Project Engineer',
//             image: member4,
//             cover: mandar,
//             about: 'Structural Engineer with nearly 2 years of experience in designing industrial steel structures for the oil and gas sector. Skilled in structural analysis, detailing, and design using STAAD-Pro, ETABS, and Idea Statica. Strong understanding of international codes with hands-on expertise in warehouse, equipment support, and foundation designs.',
//             qualifications: 'Structural Engineering (M.E)',
//             // contact: '+91 9146888404',
//             email: 'mandar.pawar@structguard.com',
//             offices: 'Pune',
//             services: 'Structural Engineering',
//             markets: '------------------',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],
//             education: [
//                 'Structural Engineering (M.E)',
//                 'B-Tech (Civil Engineering)',

//             ],
//             publications: '-------------',
//         },
//         {
//             name: 'Abhishek Bhosale',
//             position: 'Structural Detailer',
//             image: member5,
//             cover: abhishesk,
//             about: 'Detail-oriented CAD Detailer with 1.5+ years of experience in preparing structural shop drawings for U.S. projects. Skilled in structural detailing, layout planning, and software like AutoCAD, STAAD-Pro, and Idea Statica. Strong foundation in framing, connections, and foundation detailing, with a growing focus on structural design and analysis.',
//             qualifications: '----',
//             // contact: '-------',
//             email: 'abhishek.bhosale@structguard.com',
//             offices: 'Pune',
//             services: 'Structural Engineering',
//             markets: '-------',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],
//             education: [
//                 '---------------',
//                 '---------------',

//             ],
//             publications: '-----------',
//         },
//         {
//             name: 'Raksha Choure',
//             position: 'Jr.Design Engineer',
//             image: member8,
//             cover: raksh,
//             about: 'Junior Civil Design Engineer with a solid foundation in structural design and site work. Hands-on experience through internships and current role at StructGuard Engineers LLP. Strong academic background in civil engineering and keen interest in sustainable construction methods like geopolymer concrete. Quick learner with a collaborative and proactive approach.',
//             qualifications: 'B.E. (Civil Engineering)',
//             // contact: '+91 9022962874',
//             email: 'choure.raksha@structguard.com',
//             offices: 'Pune',
//             services: 'Structural Engineering',
//             markets: '----------------',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],
//             education: [
//                 'B.E. (Civil Engineering)',
//                 'Diploma (Civil Engineering)',

//             ],
//             publications: '------------',
//         },
//         {
//             name: 'Amol Borse',
//             position: 'Jr.Structural Detailer',
//             image: member6,
//             cover: amol,
//             about: 'Motivated and detail-oriented Jr. CAD Detailer with hands-on experience in preparing 2D and 3D CAD drawings using AutoCAD and Revit. Proven ability to interpret technical drawings, develop fabrication details, and collaborate with engineers for timely project delivery. Strong problem-solving skills, quick adaptability, and a team-first mindset make me a reliable contributor in structural design environments.',
//             qualifications: 'B.E.Civil',
//             // contact: '+91 9075212843 ',
//             email: 'amol.borse@structguard.com',
//             offices: 'Pune',
//             services: 'Structural Engineering',
//             markets: '----------------',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],
//             education: [
//                 'B.E.Civil',
//                 'Diploma (Civil Engineering)',

//             ],
//             publications: '-----------',
//         },
//         {
//             name: 'Shweta Chandwale',
//             position: 'Jr.Design Engineer',
//             image: member7,
//             cover: shweta,
//             about: 'Civil and Structural Engineer with hands-on experience in telecom tower design, foundation analysis, and CAD drafting. Skilled in AutoCAD and STAAD Pro, with a track record of supporting cross-functional teams and delivering safe, compliant structures. Detail-oriented, quick learner, and a strong team player.',
//             qualifications: 'B.E.Civil',
//             // contact: '+91 8208264536 ',
//             email: 'shweta.chandawale@structguard.com',
//             offices: 'Pune',
//             services: 'Structural Engineering',
//             markets: '----------------',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],
//             education: [
//                 'B.E.Civil',
//                 'Diploma (Civil Engineering)',

//             ],
//             publications: '--------------',
//         },
//         {
//             name: 'Vaishanvi Bhalerao',
//             position: 'HR / Finance',
//             image: member9,
//             cover: Vaishanvi,
//             about: 'Finance professional with an MBA in Accounting and Finance (2025) and over a year of experience as a Financial Advisor. Skilled in financial modeling, accounting, and client relationship management. Committed to delivering strategic financial solutions and building a strong foundation in investment planning and advisory services.',
//             qualifications: 'Master of Business Administration (MBA)',
//             // contact: '+91 7448154616',
//             email: 'vaishnavi.bhalerao@structguard.com',
//             offices: 'Pune',
//             services: ' Accounting and Finance',
//             markets: '----------------',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],
//             education: [
//                 'Master of Business Administration (MBA)',
//                 '---------------',

//             ],
//             publications: '--------------',
//         },
//         {
//             name: 'Janvi Gaddam',
//             position: 'BDE',
//             image: member10,
//             cover: janvi,
//             about: 'MBA graduate in Finance (2025) with a strong foundation in financial management, investment analysis, and business strategy. Experienced as a Business Development Executive with a proven ability to identify growth opportunities, manage client relationships, and support project execution. Combines financial knowledge with strategic thinking and communication skills to drive business success.',
//             qualifications: 'Master of Business Administration (MBA)',
//             // contact: '+91 9518774119',
//             email: 'janvi.gaddam@structguard.com',
//             offices: 'Pune',
//             services: 'HR & Finance',
//             markets: '----------------',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],
//             education: [
//                 'Master of Business Administration (MBA)',
//                 '---------------',

//             ],
//             publications: '--------------',
//         },
//         {
//             name: 'Ashish More',
//             position: 'Developer / BDE',
//             image: member11,
//             cover: ashish,
//             about: 'Frontend Developer with 1.5+ years of experience specializing in React.js and React Native. Strong background in JavaScript, HTML, CSS, and SQL, with hands-on expertise in building responsive web and mobile applications. Known for strong time management, problem-solving, and a passion for clean, scalable code.',
//             qualifications: 'Master of Computer Science',
//             // contact: '+91 9657920009',
//             email: 'ashish.more@structguard.com',
//             offices: 'Pune',
//             services: '---------',
//             markets: '----------------',
//             expertise: [
//                 '---------------',
//                 '-----------',
//                 '-------------',
//                 '-----------------',
//             ],
//             education: [
//                 'Master of Computer Science (M-CS)',
//                 'Bachelor of Computer Science (B-CS)',

//             ],
//             publications: '--------------',
//         },
//     ]
//     // Merge directors and team members for single grid
//     const allMembers = [...directors, ...teamMembers];

//     return (
//         <div style={styles.container}>
//             <h2 style={styles.title}>Senior Staff</h2>

//             <div style={styles.grid}>
//                 {allMembers.map((member, index) => (
//                     <motion.div
//                         key={index}
//                         style={styles.card}
//                         whileHover={{ scale: 1.02 }}
//                         onClick={() => navigate('/SecTeamMemberDetails', { state: { member } })}
//                     >
//                         <div style={styles.imageWrapper}>
//                             <img src={member.image} alt={member.name} style={styles.image} />
//                         </div>
//                         <p style={styles.position}>{member.position}</p>
//                         <p style={styles.name}>{member.name}</p>
//                     </motion.div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// const styles = {
//     container: {
//         backgroundColor: '#fff',
//         padding: '4rem 2rem',
//         fontFamily: 'Segoe UI, sans-serif',
//     },
//     title: {
//         textAlign: 'left',
//         fontSize: '1.8rem',
//         fontWeight: '600',
//         color: '#000',
//         marginBottom: '2rem',
//         marginLeft: '10%',
//     },
//     grid: {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
//         gap: '3rem 2rem',
//         maxWidth: '1200px',
//         margin: '0 auto',
//     },
//     card: {
//         textAlign: 'center',
//         cursor: 'pointer',
//     },
//     imageWrapper: {
//         width: '100%',
//         height: '260px',
//         overflow: 'hidden',
//         backgroundColor: '#f5f5f5',
//     },
//     image: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//         display: 'block',
//     },
//     position: {
//         fontSize: '0.9rem',
//         color: '#666',
//         marginTop: '1rem',
//         marginBottom: '0.3rem',
//     },
//     name: {
//         fontSize: '1rem',
//         color: '#000',
//         fontWeight: '500',
//     },
// };

// export default OurTeam;

// import React from "react";
// import director1 from '../Images/TeamPhotos/sanket Background Removed.png';
// import director2 from '../Images/TeamPhotos/Gaurav_New5 Background Removed.png';
// import member1 from '../Images/employeimges copy/AFF_8978 copy.jpg';
// import member2 from '../Images/employeimges copy/IMG_3773.jpg';
// import member3 from '../Images/employeimges copy/AFF_8962 copy.jpg';
// import member4 from '../Images/employeimges copy/AFF_8961 copy.jpg';
// import member5 from '../Images/employeimges copy/AFF_8967 copy.jpg';
// import member6 from '../Images/employeimges copy/AFF_8969 copy.jpg';
// import member7 from '../Images/employeimges copy/AFF_8975 copy.jpg';
// import member8 from '../Images/employeimges copy/AFF_8968 copy.jpg';
// import member9 from '../Images/employeimges copy/AFF_8965 copy.jpg';
// import member10 from '../Images/employeimges copy/AFF_8981 copy.jpg';
// import member11 from '../Images/employeimges copy/AFF_8973 copy.jpg';
// import ajita from '../Images/employeimges copy/fullsize/ajitacover.png';
// import praful from '../Images/employeimges copy/fullsize/prafullnewcover.png';
// import minal from '../Images/employeimges copy/fullsize/minalcover.png';
// import mandar from '../Images/employeimges copy/fullsize/mandarcover.png';
// import abhishesk from '../Images/employeimges copy/fullsize/abhicover.png';
// import amol from '../Images/employeimges copy/fullsize/amolcover.png';
// import shweta from '../Images/employeimges copy/fullsize/swetacover.png';
// import raksh from '../Images/employeimges copy/fullsize/rakshacover.png';
// import Vaishanvi from '../Images/employeimges copy/fullsize/vaishnavicover.png';
// import janvi from '../Images/employeimges copy/fullsize/janvi2cover.png';
// import ashish from '../Images/employeimges copy/fullsize/ashishcover.png';

// const teamMembers = [
//   {
//     name: "Ajita Kulkarni",
//     position: "Managing Director",
//     id: "ID #000001",
//     image: member1
//   },
//   {
//     name: "Gaurav Patil",
//     position: "Project Manager",
//     id: "ID #000002",
//     image:director2
//   },
//   {
//     name: "Sanket Deshmukh",
//     position: "Structural Engineer",
//     id: "ID #000003",
//     image:director1
//   }
//   // Add more members here
// ];

// const styles = {
//   grid: {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     gap: "2rem",
//     padding: "2rem",
//     background: "#f5f5f5"
//   },
//   card: {
//     width: "260px",
//     borderRadius: "12px",
//     overflow: "hidden",
//     background: "#fff",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//     fontFamily: "sans-serif",
//     display: "flex",
//     flexDirection: "column"
//   },
//   imageWrapper: {
//     position: "relative",
//     height: "300px",
//     background: "#eee"
//   },
//   image: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover"
//   },
//   infoSection: {
//     padding: "1rem",
//     background: "#fff"
//   },
//   name: {
//     fontSize: "1.2rem",
//     fontWeight: "bold",
//     color: "#000",
//     margin: "0 0 0.3rem 0"
//   },
//   position: {
//     fontSize: "0.9rem",
//     color: "#555",
//     marginBottom: "0.5rem"
//   },
//   idText: {
//     fontSize: "0.8rem",
//     color: "#999"
//   }
// };

// export default function TeamIDCards() {
//   return (
//     <div style={styles.grid}>
//       {teamMembers.map((member, index) => (
//         <div style={styles.card} key={index}>
//           <div style={styles.imageWrapper}>
//             <img src={member.image} alt={member.name} style={styles.image} />
//           </div>
//           <div style={styles.infoSection}>
//             <div style={styles.name}>{member.name}</div>
//             <div style={styles.position}>{member.position}</div>
//             <div style={styles.idText}>{member.id}</div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }
